
export default {
  name: 'AppSelect',
  model: { event: 'change' },
  props: {
    id: { type: String, required: true },
    name: { type: String, required: true },
    value: { type: [String, Number], default: null },
    options: { type: Array, required: true }
  },
  data() {
    return {
      currentValue: this.value,
      valueType:
        typeof this.options.slice(-1)[0].value === 'number' ? Number : String
    };
  },
  watch: {
    value() {
      this.currentValue = this.value;
    }
  },
  methods: {
    change(newValue) {
      if (this.currentValue === newValue) return;

      this.currentValue = this.castedValue(newValue);
      this.$emit('change', this.currentValue);
    },
    castedValue(value) {
      if (value === null) return null;

      return this.valueType === Number ? parseInt(value) : String(value);
    }
  }
};
